import React from 'react';

import * as api from '_core/utils/api';
import { useVisitorInfo } from '_core/utils/visitorInfo';
import { SelectInput } from '_core/components/SelectInput';


const LOADING_OPTIONS = [
  { id: 'loading', title: '$r._.userinput.text.loading' }
];

const loadCardList = async (visitorId, setCardList) => {
  const token = await api.getClientTokenGenerate(visitorId);
  
  try {
    setCardList((await api.getMoneyCard(token))
      .filter((card) => card.type > 200 && (!card.flags || card.flags.indexOf('blocked') < 0))
      .map((card) => ({ ...card })));
  } catch (e) {
    console.error(e);
    
    setCardList([]);
  }
};

const RawCard2Input = (props) => {
  const visitorInfo = useVisitorInfo();
  
  const [cardList, setCardList] = React.useState(undefined);
  
  const visitorId = visitorInfo.info?.id;
  
  React.useEffect(() => {
    loadCardList(visitorId, setCardList);
  }, [visitorId, setCardList]);
  
  
  if (!cardList) {
    const selectProps = {
      ...props,
      
      key: 'loading',
      disabled: true,
      options: LOADING_OPTIONS,
      defaultValue: LOADING_OPTIONS[0]
    };
    
    delete selectProps.error;
    delete selectProps.helperText;
    delete selectProps.value;
    delete selectProps.onChange;
    delete selectProps.setFieldValue;
    
    return (
      <SelectInput
        {...selectProps}
      />
    );
  }
  
  return (
    <SelectInput
      {...props}
      
      key="cards"
      options={cardList}
      defaultValue={cardList[0]}
    />
  );
};

RawCard2Input.defaultProps = {};

RawCard2Input.propTypes = {};

export const Card2Input = RawCard2Input;
